import type { FaceDetectResult } from '../types';

export const getHintsPhoto = (faceDetectResult: FaceDetectResult): string => {
    if (!faceDetectResult.isFaceFound) {
        return 'docVerificationWizard.liveness.faceNotFound';
    }

    if (!faceDetectResult.isCenter && faceDetectResult.isFaceFound) {
        return 'docVerificationWizard.liveness.alignFace';
    }

    if (!faceDetectResult.isLookingStraight) {
        return 'docVerificationWizard.liveness.lookStraight';
    }

    if (faceDetectResult.facePercent.hint === 'small') {
        return 'docVerificationWizard.liveness.moveCloser';
    }

    if (faceDetectResult.facePercent.hint === 'big') {
        return 'docVerificationWizard.liveness.backward';
    }

    if (faceDetectResult.isSuccess) {
        return 'docVerificationWizard.liveness.dontMove';
    }

    return 'docVerificationWizard.liveness.textMask';
};
